<script lang="ts">
import { defineComponent, onActivated, onMounted, PropType, ref } from "vue";
import Bestaetigung from "@/components/abschluss/Bestaetigung.vue";
import Newsbanner from "@/components/newsbanner/Newsbanner.vue";
import CrossSelling from "@/components/cross-selling/CrossSelling.vue";
import { NavvItem } from "@/model/NavItem";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "BestaetigungHG",
  components: { CrossSelling, Newsbanner, Bestaetigung },
  emits: ["prev-page", "next-page", "goto-page", "handle-error"],
  props: {
    navItems: Object as PropType<NavvItem[]>,
  },
  setup(props, { emit }) {
    const piniaStore = useFormStore();
    const isMakler = ref();
    const isMaklerLink = ref();

    onMounted(() => {
      isMakler.value = piniaStore.state.isMakler;
      isMaklerLink.value = piniaStore.state.isMaklerLink;

      piniaStore.resetState();
    });

    onActivated(() => {
      window.onpopstate = function () {
        emit("goto-page", { pageIndex: 0 });
        window.onpopstate = null;
      };
    });

    return {
      piniaStore,
      isMakler,
    };
  },
});
</script>

<template>
  <bestaetigung />
  <newsbanner v-if="!isMakler" />
  <cross-selling v-if="!isMakler" :produkte="['vgv', 'hr', 'phv']" />
</template>
